import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components';

export default buildFacetDesignOverride()
  .nameOverride('reductionPermitted', { _component: () => CheckboxInputLarge }, { ordinal: overrideReadOnly.ordinal + 1 })
  .typeOverride('picklist', {
    _customProps: {
      fullWidth: true,
    },
  })
  .nameOverride('expenseCategoryName', {
    _formatReadOnly: () => (_, { resource, attrName }) => resource.selectedOptions(attrName, 'id').join(', '),
    _customProps: {
      showReadOnlyOptions: true,
    },
  });
